import HTTP from '@/utils/http';
import { EventBus } from '@/utils/event-bus';
import i18n from '@/locales';
import moment from 'moment';

const defaultState = () => ({
  methods: [],
});

const paymentMethodsModule = {
  namespaced: true,
  state: defaultState(),
  mutations: {
    RESET_STATE(state) {
      Object.assign(state, defaultState());
    },
    SET_PAYMENT_METHODS(state, { methods }) {
      state.methods = methods;
    },
  },
  actions: {
    RESET_STATE({ commit }) {
      commit('RESET_STATE');
    },
    GET({ commit }) {
      return HTTP({
        url: 'payment-methods',
      }).then((response) => {
        commit('SET_PAYMENT_METHODS', { methods: response.data.data });
      }).catch(() => {
        EventBus.$emit('renderGlobalMessage', ({ message: i18n.t('message.fail.fetch', { name: 'payment methods' }), icon: 'times', type: 'error' }));
      });
    },
    GET_CLIENT_SECRET() {
      return HTTP({
        method: 'post',
        url: 'payment-methods/setup-intent',
      }).then(response => response.data.data);
    },
    CREATE_CARD({ commit }, paymentMethodId) {
      return HTTP({
        method: 'post',
        url: 'payment-methods/card',
        data: paymentMethodId,
      }).then((response) => {
        commit('SET_PAYMENT_METHODS', { methods: response.data.data });
        EventBus.$emit('renderGlobalMessage', ({ message: i18n.t('message.success.add', { name: 'payment method' }), icon: 'check', type: 'success' }));
      }).catch(() => {
        EventBus.$emit('renderGlobalMessage', ({ message: i18n.t('message.fail.add', { name: 'payment method' }), icon: 'times', type: 'error' }));
      });
    },
    CREATE_DD({ commit }, details) {
      return HTTP({
        method: 'post',
        url: 'payment-methods/direct-debit',
        data: details,
      }).then((response) => {
        commit('SET_PAYMENT_METHODS', { methods: response.data.data });
        EventBus.$emit('renderGlobalMessage', ({ message: i18n.t('message.success.add', { name: 'payment method' }), icon: 'check', type: 'success' }));
        return response.data.data;
      }).catch((error) => {
        EventBus.$emit('renderGlobalMessage', ({ message: i18n.t('message.fail.add', { name: 'payment method' }), icon: 'times', type: 'error' }));
        return { createError: error };
      });
    },
    DELETE_METHOD({ commit }, { id }) {
      return HTTP({
        method: 'delete',
        url: `payment-methods/${id}`,
      }).then((response) => {
        commit('SET_PAYMENT_METHODS', { methods: response.data.data });
        EventBus.$emit('renderGlobalMessage', ({ message: i18n.t('message.success.removed', { name: 'payment method' }), icon: 'check', type: 'success' }));
      }).catch(() => {
        EventBus.$emit('renderGlobalMessage', ({ message: i18n.t('message.fail.remove', { name: 'payment method' }), icon: 'times', type: 'error' }));
      });
    },
    SWITCH_DEFAULT_METHOD({}, { id }) { // eslint-disable-line no-empty-pattern
      return HTTP({
        method: 'put',
        url: 'payment-methods/default',
        data: {
          id,
        },
      }).then(() => {
        EventBus.$emit('renderGlobalMessage', ({ message: i18n.t('message.success.switch', { name: 'default payment method' }), icon: 'check', type: 'success' }));
      });
    },
  },
  getters: {
    results: state => state.methods,
    defaultMethod: state => state.methods?.find(method => method.is_default),
    defaultCardHasExpired: (state, getters) => {
      if (!getters.defaultMethod) {
        return null;
      } else
      if (getters.defaultMethod.type !== 'Card') {
        return false;
      }
      const now = moment.utc();
      const defaultExpiry = moment(now) // cloning now variable to have an accurate comparison
        .set('year', getters.defaultMethod.card.exp_year)
        .set('month', getters.defaultMethod.card.exp_month - 1) // months are inexplicably zero indexed
        .endOf('month'); // the true expiry of a card is midnight on the last day of the expiry month
      return defaultExpiry.isSameOrBefore(now);
    },
  },
};

export default paymentMethodsModule;
